import React from 'react';
import { featureHelpers } from './feature-helpers';

export function requireFeature(Component, requiredFeatures) {
  class HiddenContent extends React.Component {
    render() {
      return (
        <h1 id="hide-display">Feature Coming Soon</h1>
      );
    }
  }
  var featuresEnabled = featureHelpers.featuresEnabled(requiredFeatures);
  if(featuresEnabled)
    return Component;
  else
    return HiddenContent;
}
